import { getAggregatePeriodFromDateRange } from '@modules/common/utils';
import { useSearchAnalysesWhereClause } from '@modules/feed/hooks';
import { useFeedStore } from '@modules/feed/store/feedStore';
import { useMemo } from 'react';
import { AggregatePeriod, TimeRange } from 'v2/core/entities';

export const useGetSearchQueryContainer = () => {
  const duration = useFeedStore(({ query }) => query.duration);
  const whereClause = useSearchAnalysesWhereClause();

  return useMemo(() => {
    return {
      AggregatePeriod: getAggregatePeriodFromDateRange(
        duration,
      ) as AggregatePeriod,
      DateRange: duration as TimeRange,
      WhereClause: whereClause,
    };
  }, [duration, whereClause]);
};
